(function () {
  function isMobile() {
    return window.matchMedia("(max-width: 989px)").matches;
  }

  function getSectionId(galleryEl) {
    return (galleryEl.id || "").replace("MediaGallery-", "");
  }

  function getItems(sectionId) {
    const jsonEl = document.getElementById(`ProductMediaJson-${sectionId}`);
    if (!jsonEl) return [];
    let media = [];
    try { media = JSON.parse(jsonEl.textContent) || []; } catch (e) {}

    // images only
    const imgs = media.filter(m => m && m.media_type === "image" && (m.image || m.preview_image));
    return imgs.map(m => {
      const img = m.image || m.preview_image;
      return {
        src: img.src,
        width: img.width || 1600,
        height: img.height || 1600
      };
    }).filter(i => i.src);
  }

function openPS(items, index) {
  const Lightbox = window.PhotoSwipeLightbox;
  const PS = window.PhotoSwipe;
  if (!Lightbox || !PS) return;

  const lightbox = new Lightbox({
    dataSource: items,
    pswpModule: PS,

    // ✅ Open fullscreen but FIT inside screen (not oversized)
    initialZoomLevel: 'fit',

    // ✅ Allow pinch out back to fit
    minZoomLevel: 'fit',

    // Optional: double-tap zoom target
    secondaryZoomLevel: 2.5,

    // Optional: maximum pinch zoom
    maxZoomLevel: 4,

    // ✅ Prevent pinch-out being treated as "close"
    pinchToClose: false
  });

  lightbox.init();
  lightbox.loadAndOpen(index || 0);

  lightbox.on("close", () => {
    try { lightbox.destroy(); } catch (e) {}
  });
}


  function bind(galleryEl) {
    const sectionId = getSectionId(galleryEl);
    if (!sectionId) return;

    const items = getItems(sectionId);
    if (!items.length) return;

    const mediaList = galleryEl.querySelector(".product__media-list");
    if (!mediaList) return;

    // Capture phase so we beat Trade's default click handler
    mediaList.addEventListener("click", function (e) {
      if (!isMobile()) return;

      const opener = e.target.closest(".product__modal-opener, .product__media-item, img");
      if (!opener) return;

      e.preventDefault();
      e.stopPropagation();

      // Determine current slide index
      let index = 0;
      const active = mediaList.querySelector(".product__media-item.is-active");
      if (active && active.dataset && active.dataset.mediaId) {
        // Find the active image position by matching order in JSON
        // (best-effort: active slide usually corresponds to same order)
        const liList = Array.from(mediaList.querySelectorAll(".product__media-item"));
        const activeIdx = liList.indexOf(active);
        if (activeIdx >= 0) index = activeIdx;
      }

      openPS(items, index);
    }, true);
  }

  function init() {
    // wait for scripts (defer)
    if (!window.PhotoSwipe || !window.PhotoSwipeLightbox) {
      setTimeout(init, 50);
      return;
    }
    document.querySelectorAll("media-gallery[id^='MediaGallery-']").forEach(bind);
  }

  document.addEventListener("DOMContentLoaded", init);
})();
